import { styled, Theme } from '@mui/system';
import { COLORS } from '../../../../../../common/Styleguide/Common/colors';

export const Root = styled('div')(({ theme: { spacing } }: { theme: Theme }) => ({
  height: 'auto',
  display: 'flex',
  alignItems: 'center',
  overflowX: 'auto',
  marginBottom: 1,
  gap: spacing(4),
}));

interface ActiveProps {
  active: boolean;
}

export const NumberContainer = styled('div', { shouldForwardProp: (prop) => prop !== 'active' })<ActiveProps>(({ active }) => ({
  background: active ? COLORS.brand[100] : COLORS.black[10],
  color: active ? COLORS.white[100] : COLORS.black[90],
  width: 30,
  height: 30,
  display: 'flex',
  borderRadius: 30,
  justifyContent: 'center',
  alignItems: 'center',
  fontSize: 16,
  fontWeight: 800,
}));

export const PathItem = styled('div', { shouldForwardProp: (prop) => prop !== 'active' })<ActiveProps>(({ active }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  fontSize: 14,
  fontWeight: 700,
  color: active ? COLORS.white[80] : COLORS.black[10],
  textAlign: 'center',
}));

export const LabelText = styled('div')(({ theme: { spacing } }: { theme: Theme }) => ({
  marginTop: spacing(1),
}));
